//Types for Authentication
//Account Creation
export const START_ACCOUNT_CREATION = 'START_ACCOUNT_CREATION'
export const STOP_ACCOUNT_CREATION = 'STOP_ACCOUNT_CREATION'
export const ERROR_WHEN_CREATING_ACCOUNT = 'ERROR_WHEN_CREATING_ACCOUNT'

//Account Logging
export const START_LOG_INTO_ACCOUNT = 'START_LOG_INTO_ACCOUNT'
export const STOP_LOG_INTO_ACCOUNT = 'STOP_LOG_INTO_ACCOUNT'
export const LOG_OFF_ACCOUNT = 'LOG_OFF_ACCOUNT'
export const ERROR_WHEN_LOGGING = 'ERROR_WHEN_LOGGING'

//Checkout ADD
export const START_ADDING_TO_CART = 'START_ADDING_TO_CART'
export const STOP_ADDING_TO_CART = 'STOP_ADDING_TO_CART'
export const ERROR_WHEN_ADDING_TO_CART = 'ERROR_WHEN_ADDING_TO_CART'

//Checkout REMOVE
export const START_REMOVING_FROM_CART = 'START_REMOVING_FROM_CART'
export const STOP_REMOVING_FROM_CART = 'STOP_REMOVING_FROM_CART'
export const ERROR_WHEN_REMOVING_FROM_CART = 'ERROR_WHEN_REMOVING_FROM_CART'

//Checkout Buy
export const START_BUYING_CART = 'START_BUYING_CART'
export const STOP_BUYING_CART = 'STOP_BUYING_CART'
export const ERROR_WHEN_BUYING_CART = 'ERROR_WHEN_BUYING_CART'

//Checkout Update
export const START_UPDATING_CART = 'START_UPDATING_CART'
export const STOP_UPDATING_CART = 'STOP_UPDATING_CART'
export const ERROR_WHEN_UPDATING_CART = 'ERROR_WHEN_UPDATING_CART'

